export const constants = {
	TWENTY_FOUR_HR_PC: 'TWENTY_FOUR_HR_PC',
	PERCENT_CHANGE:	'24hr percent change',
	MARKET_CAP: 'MARKET CAP',	
}